import React from 'react';
import CommunityNavSubHeaderDesktop from './CommunityNavSubHeaderDesktop/CommunityNavSubHeaderDesktop';
import CommunityNavSubHeaderMobile from './CommunityNavSubHeaderMobile/CommunityNavSubHeaderMobile';

interface Props {
  className?: string;
  isMobile?: boolean;
}

const CommunityNavSubHeader = ({ className, isMobile = false }: Props) => {
  if (isMobile) {
    return <CommunityNavSubHeaderMobile className={className} />;
  }

  return <CommunityNavSubHeaderDesktop className={className} />;
};

export default CommunityNavSubHeader;
